import { useState, useRef, useEffect } from 'react';

function SMSSelectHPByUserPopup(props: any) {
  let myProps = {
    callback_data: (inData: any) => { },
    closePopup: () => { },
    ...props
  };

  let select_opt_arr: any = [
    { "value": "par1", "text": "보호자" },
    { "value": "par2", "text": "기타보호자" },
    { "value": "student", "text": "원생" },
  ];

  const [select_opt, set_select_opt] = useState<any>({
    "student": false,
    "par1": false,
    "par2": false,
  });

  useEffect(() => {

  }, []);

  const get_select_hp_button_tags = () => {
    let button_tags = select_opt_arr.map((item: any, index: number) => {
      let is_selected = select_opt[item["value"]];
      return (
        <label key={index} className="ml-1">
          <input type="checkbox" name="select_opt" value="1" checked={is_selected}
            onChange={(e: any) => {
              let name = item["value"];
              let value = e.target.checked;
              let new_select_opt = { ...select_opt };
              new_select_opt[name] = value;
              set_select_opt(new_select_opt);
            }} />
          <span className="ml-1" style={{ fontSize: "16px" }}>
            {item["text"]}
          </span>
        </label>
      );
    });
    return button_tags;
  };

  return (
    <div>
      <div style={{ fontSize: "20px", textAlign: "center", marginBottom: "10px" }}>
        SMS 발송 (수신)대상
      </div>
      <div className="text-center" style={{ fontSize: "14px" }}>
        {get_select_hp_button_tags()}
      </div>
      <div className="mt-2" style={{ position: "absolute", width: "100%", bottom: "10px", textAlign: "right", paddingRight: "30px" }}>
        <button className="btn btn-gray-text btn-medium-w"
          onClick={() => {
            myProps.callback_data({ select_opt: select_opt });
            myProps.closePopup();
          }}>확인</button>
        <button className="btn btn-gray-text btn-medium-w ml-2"
          onClick={() => { myProps.closePopup(); }}>취소</button>
      </div>
    </div>
  );
}

export default SMSSelectHPByUserPopup;
